import 'whatwg-fetch';
import '../polyfills';
import '../components/ImagesLazyLoading';
import '../components/LinksActive';
import '../components/NotifyWidget';
import ExitPopup from '../components/ExitPopup';
import exitPopupTheme from '../data/exitPopupTemplates';
import '../components/RefererWebmaster';

if (document.querySelector('[data-exit-popup-js]')) {
  const popup = new ExitPopup({
    container: '[data-exit-popup-js]',
    storage: 'cookie',
    template: exitPopupTheme,
    gaEventLabel: 'STEM exit popup',
    bannerName: 'get-discount',
    customClass: 'ExitPopup--get-discount',
    hideForExistsUsers: true,
    analytics: {
      type: 'ga',
    },
  });
  popup.init();
}
